<div class="main-page cadastros journey-main">
  <div class="container-fluid">
    <div class="row align-items-center">
      <div class="col-12 my-2">
        <h1>Relatório de Posições</h1>
      </div>
    </div>
    <div
      style="
        background-color: #1e3f7a;
        padding: 10px 20px;
        border-radius: 4px;
        margin-bottom: 20px;
      "
      class="d-flex justify-content-between align-items-center flex-wrap"
    >
      <div>
        <button mat-button (click)="onOpenDialogFilter()" style="color: white">
          <mat-icon style="color: white">filter_list</mat-icon>
          Filtrar
        </button>
      </div>
      <div>
        <button
          mat-stroked-button
          (click)="exportExcel()"
          style="color: white; border-color: white; margin-right: 10px"
        >
          <mat-icon style="color: white">table_view</mat-icon>
          Excel
        </button>
        <button
          mat-stroked-button
          (click)="exportPdf()"
          style="color: white; border-color: white"
        >
          <mat-icon style="color: white">picture_as_pdf</mat-icon>
          PDF
        </button>
      </div>
    </div>

    <mat-horizontal-stepper [linear]="true" #stepper>
      <mat-step>
        <!-- COMECA -->
        <p-table
          #journeyheader
          [value]="this.resultado"
          tableStyleClass="table"
        >
          <ng-template pTemplate="header" let-columns>
            <tr [hidden]="this.resultado.length == 0">
              <th style="text-align: center !important; border: none">
                Data Inicio
              </th>
              <th style="text-align: center !important; border: none">
                Data Fim
              </th>
              <th
                style="text-align: center !important; width: 80px; border: none"
              >
                Tempo Ignição Desligada
              </th>
              <th
                style="text-align: center !important; width: 40px; border: none"
              >
                Horímetro
              </th>
              <th style="text-align: center !important; border: none">
                Latitude
              </th>
              <th style="text-align: center !important; border: none">
                Longitude
              </th>
              <th
                style="
                  text-align: center !important;
                  width: 180px;
                  border: none;
                "
              >
                Endereço
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowdata>
            <tr [hidden]="this.resultado.length == 0">
              <td
                style="
                  text-align: center !important;
                  padding: 10px !important;
                  border: none;
                "
                align="center"
                valign="middle"
                [pRowToggler]="rowdata"
              >
                {{ rowdata["dataInicio"] }}
              </td>
              <td
                style="
                  text-align: center !important;
                  padding: 10px !important;
                  border: none;
                "
                align="center"
                valign="middle"
                [pRowToggler]="rowdata"
              >
                {{ rowdata["dataFim"] }}
              </td>
              <td
                style="
                  text-align: center !important;
                  padding: 10px !important;
                  border: none;
                "
                align="center"
                valign="middle"
                [pRowToggler]="rowdata"
              >
                {{ rowdata["tempoIgnicaoDesligada"] }}
              </td>
              <td
                style="
                  text-align: center !important;
                  padding: 10px !important;
                  border: none;
                "
                align="center"
                valign="middle"
                [pRowToggler]="rowdata"
              >
                {{ rowdata["horimetro"] }}
              </td>
              <td
                style="
                  text-align: center !important;
                  padding: 10px !important;
                  border: none;
                "
                align="center"
                valign="middle"
                [pRowToggler]="rowdata"
              >
                {{ rowdata["latitude"] }}
              </td>
              <td
                style="
                  text-align: center !important;
                  padding: 10px !important;
                  border: none;
                "
                align="center"
                valign="middle"
                [pRowToggler]="rowdata"
              >
                {{ rowdata["longitude"] }}
              </td>
              <td
                style="
                  text-align: center !important;
                  padding: 10px !important;
                  border: none;
                "
                align="center"
                valign="middle"
                [pRowToggler]="rowdata"
              >
                {{ rowdata["endereco"] }}
              </td>
            </tr>
          </ng-template>
        </p-table>
        <!-- FIM -->
        <!-- COMECA -->
        <p-table
          #journeyheader
          [value]="this.resultadoTotal"
          tableStyleClass="table-total"
        >
          <ng-template pTemplate="header" let-columns>
            <tr [hidden]="this.resultadoTotal.length == 0">
              <th style="text-align: center !important; border: none">Frota</th>
              <th style="text-align: center !important; border: none">Placa</th>
              <th style="text-align: center !important; border: none">
                Motorista
              </th>
              <th style="text-align: center !important; border: none">
                Tempo Ignição Desligada Total
              </th>
              <th style="text-align: center !important; border: none">
                KM Percorrido
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowdata>
            <tr [hidden]="this.resultadoTotal.length == 0">
              <td
                style="
                  text-align: center !important;
                  padding: 10px !important;
                  border: none;
                "
                align="center"
                valign="middle"
                [pRowToggler]="rowdata"
              >
                {{ rowdata["frota"] }}
              </td>
              <td
                style="
                  text-align: center !important;
                  padding: 10px !important;
                  border: none;
                "
                align="center"
                valign="middle"
                [pRowToggler]="rowdata"
              >
                {{ rowdata["placa"] }}
              </td>
              <td
                style="
                  text-align: center !important;
                  padding: 10px !important;
                  border: none;
                "
                align="center"
                valign="middle"
                [pRowToggler]="rowdata"
              >
                {{ rowdata["motorista"] }}
              </td>
              <td
                style="
                  text-align: center !important;
                  padding: 10px !important;
                  border: none;
                "
                align="center"
                valign="middle"
                [pRowToggler]="rowdata"
              >
                {{ rowdata["tempoTotalIgnicaoDesligada"] }}
              </td>
              <td
                style="
                  text-align: center !important;
                  padding: 10px !important;
                  border: none;
                "
                align="center"
                valign="middle"
                [pRowToggler]="rowdata"
              >
                {{ rowdata["kmPercorrido"] }} KM
              </td>
            </tr>
          </ng-template>
        </p-table>
        <!-- FIM-->
                 <!-- COMECA -->
         <p-table
           #journeyheader
           [value]="this.resultadoAnalitico"
           tableStyleClass="tableAnalitico"
         >
           <ng-template pTemplate="header" let-columns>
             <tr
               [hidden]="this.resultadoAnalitico.length == 0"
               id="tabela-analitico"
               [ngClass]="this.filterDialog == true ? '' : 'sticky-top'"
             >
               <th class="th-analitico">Data</th>
               <th class="th-analitico">Placa</th>
               <th class="th-analitico">Frota</th>
               <th class="th-analitico">Motorista</th>
               <th class="th-analitico">Status Ignição</th>
               <th class="th-analitico">Odômetro</th>
               <th class="th-analitico">RPM</th>
               <th class="th-analitico">Velocidade</th>
               <th class="th-analitico">Tipo Velo.</th>
               <th class="th-analitico">KM Percorrido</th>
               <th class="th-analitico">Latitude</th>
               <th class="th-analitico">Longitude</th>
               <th class="th-analitico">Endereço</th>
             </tr>
           </ng-template>

           <ng-template pTemplate="body" let-rowdata>
             <tr>
               <td class="td-analitico" [pRowToggler]="rowdata">
                 {{ rowdata["dataAtualizacao"] }}
               </td>
               <td class="td-analitico" [pRowToggler]="rowdata">
                 {{ rowdata["placa"] }}
               </td>
               <td class="td-analitico" [pRowToggler]="rowdata">
                 {{ rowdata["frota"] }}
               </td>
               <td class="td-analitico" [pRowToggler]="rowdata">
                 {{ rowdata["motoristaNome"] }}
               </td>
               <td class="td-analitico status-cell" [pRowToggler]="rowdata">
                 <span 
                   [ngClass]="{
                     'status-desligada': rowdata['statusIgnicao'] === 'IGNIÇÃO DESLIGADA',
                     'status-ligada': rowdata['statusIgnicao'] === 'IGNIÇÃO LIGADA',
                     'status-vazio': !rowdata['statusIgnicao'] || rowdata['statusIgnicao'] === 'NÃO CONTÉM'
                   }">
                   {{ rowdata["statusIgnicao"] || '-' }}
                 </span>
               </td>
               <td class="td-analitico" [pRowToggler]="rowdata">
                 {{ rowdata["odometro"] }}
               </td>
               <td class="td-analitico" [pRowToggler]="rowdata">
                 {{ rowdata["rpm"] }}
               </td>
               <td class="td-analitico" [pRowToggler]="rowdata">
                 {{ rowdata["velocidade"] }} KM
               </td>
               <td class="td-analitico" [pRowToggler]="rowdata">
                 {{ rowdata["tipoVelocidade"] }}
               </td>
               <td class="td-analitico" [pRowToggler]="rowdata">
                 {{ rowdata["kmPercorrido"] }} KM
               </td>
               <td class="td-analitico" [pRowToggler]="rowdata">
                 {{ rowdata["latitude"] }}
               </td>
               <td class="td-analitico" [pRowToggler]="rowdata">
                 {{ rowdata["longitude"] }}
               </td>
               <td class="td-analitico endereco-cell" [pRowToggler]="rowdata">
                 <span *ngIf="!consultaFormGroup.get('searchAddress')?.value">
                   <button 
                     type="button" 
                     class="btn-visualizar"
                     (click)="openMap(rowdata['latitude'], rowdata['longitude'])"
                     matTooltip="Visualizar no mapa">
                     <img src="assets/img/view.svg" alt="Ver mapa" height="15" />
                   </button>
                 </span>
                 <span *ngIf="consultaFormGroup.get('searchAddress')?.value">
                   {{ rowdata["endereco"] }}
                 </span>
               </td>
             </tr>
           </ng-template>
         </p-table>
        <!-- FIM-->
      </mat-step>
    </mat-horizontal-stepper>
  </div>
</div>

<p-sidebar [(visible)]="this.filterDialog" position="right">
  <div style="margin-bottom: 20px">
    <span>Filtros</span>
  </div>
  <form [formGroup]="this.consultaFormGroup">
    <div class="form-row">
      <div class="form-group col-lg-12">
        <mat-form-field appearance="outline">
          <mat-label>Data Início</mat-label>
          <input
            formControlName="dataInicio"
            type="datetime-local"
            step="1"
            matInput
            placeholder="Inicio"
            required
          />
        </mat-form-field>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-lg-12">
        <mat-form-field appearance="outline">
          <mat-label>Data Fim</mat-label>
          <input
            formControlName="dataFim"
            type="datetime-local"
            step="1"
            matInput
            placeholder="Fim"
            required
          />
        </mat-form-field>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-md-8">
        <mat-form-field appearance="outline">
          <mat-label>Tipo de Empresa</mat-label>
          <mat-select
            formControlName="selecaoEmpresa"
            [(value)]="empresaFilterSelected"
            [(ngModel)]="empresaFilterSelected"
            (selectionChange)="this.filterCompanyReports()"
          >
            <mat-option
              *ngFor="let type of companiesSelect"
              [value]="type.name"
            >
              {{ type.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-md-8">
        <mat-form-field appearance="outline">
          <mat-label>Empresa</mat-label>
          <input
            type="text"
            matInput
            [formControl]="controlEmpresa"
            [matAutocomplete]="autoEmpresa"
            required
          />
          <mat-autocomplete
            #autoEmpresa="matAutocomplete"
            [displayWith]="displayEmpresa"
          >
            <mat-option
              *ngFor="let type of this.companiesFilter"
              [value]="type"
            >
              {{ type.nmNome }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-md-8">
        <mat-form-field appearance="outline" *ngIf="controlEmpresa.value != ''">
          <mat-label>Placa / Frota</mat-label>
          <input
            type="text"
            matInput
            [formControl]="controlVeiculo"
            [matAutocomplete]="autoTerminal"
            required
          />
          <mat-autocomplete
            #autoTerminal="matAutocomplete"
            [displayWith]="displayTerminal"
          >
            <mat-option
              *ngFor="let type of this.vehiclesFiltered | async"
              [value]="type"
              (onSelectionChange)="selecionarVeiculo(type)"
            >
              {{ type.cdPlaca }}/{{ type.frota }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-md-8">
        <mat-form-field appearance="outline">
          <mat-label>Motorista</mat-label>
          <input
            type="text"
            matInput
            [formControl]="controlMotorista"
            [matAutocomplete]="autoMotorista"
          />
          <mat-autocomplete
            #autoMotorista="matAutocomplete"
            [displayWith]="displayMotorista"
          >
            <mat-option
              *ngFor="let type of this.driversFiltered | async"
              [value]="type"
            >
              {{ type.nmNome }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </div>

    <!-- Dropdown de Tipo de Odômetro -->
    <div class="form-row" *ngIf="controlVeiculo.value">
      <div class="form-group col-md-8">
        <mat-form-field appearance="outline">
          <mat-label>Tipo de Odômetro:</mat-label>
          <select matNativeControl formControlName="tipoOdometro">
            <option *ngFor="let opcao of opcoesOdometro" [value]="opcao.value">
              {{ opcao.label }}
            </option>
          </select>
        </mat-form-field>
      </div>
    </div>

      <!--  <div class="form-row"
            *ngIf="this.permissionService.hasPermission('ENDERECO_INTERNO_FUNCIONALIDADE', this.permissions)">
            <div class="form-group col-md-12">
                <mat-slide-toggle name="searchAddress" formControlName="searchAddress" color="primary">
                    Buscar Endereço Internamente?</mat-slide-toggle>
            </div>
        </div> -->

    <div class="form-row">
      <div class="form-group col-md-8">
        <mat-form-field appearance="outline">
          <mat-label>Tipo:</mat-label>
          <select matNativeControl formControlName="tipoRelatorio">
            <option value="1" selected>Sintético</option>
            <option value="2">Analítico</option>
          </select>
        </mat-form-field>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-md-8">
        <!-- [disabled]="!this.lastAnswers[this.lastAnswers.length -1].msg && !this.finalizar" class="ml-1" mat-flat-button color="primary" (click)="onSave()" -->
        <button type="submit" (click)="onConsultar()">Consultar</button>
      </div>
    </div>
  </form>
</p-sidebar>
